// Door detection is UX only — authorization is always enforced server-side.
export const isPortalHost = () => window.location.hostname.startsWith("portal.");

export const isPreviewHost = () => {
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h.endsWith(".preview.emergentagent.com");
};

export const homeFor = (user) => (user && user.user_type === "client" ? "/portal" : "/");
